/**
 * 数量・重量・体積の表示形式。単位は付けず、数値の文字列だけを返す
 * （画面ごとに「164cs」「164 cs」と間隔の流儀が違うため、単位の付け方は呼び出し側に残す）。
 *
 * 画面ごとに Intl.NumberFormat を各自で持っていた結果、地図のポップアップだけ生の値を
 * そのまま出して `2886.3999999999996 kg` になっていた（指摘 2026/08/19）。
 * 丸め方と桁区切りはここに集める。
 */

const integerFormatter = new Intl.NumberFormat('ja-JP');
const decimalFormatter = new Intl.NumberFormat('ja-JP', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/** 数量 (cs)。整数で出す（合成カードの合計で端数が出ることがある） */
export function quantityValueText(cases: number): string {
  return integerFormatter.format(Math.round(cases));
}

/** 重量 (kg)。整数で出す（浮動小数の足し算で出る端数をそのまま見せない） */
export function weightValueText(kg: number): string {
  return integerFormatter.format(Math.round(kg));
}

/** 体積 (m³)。小数第 1 位まで出す（車両カード・未割当カードと同じ桁） */
export function volumeValueText(m3: number): string {
  return decimalFormatter.format(m3);
}

/** 距離 (km)。整数で出す */
export function distanceKmText(km: number): string {
  return integerFormatter.format(Math.round(km));
}

/** 時間 (h)。小数第 1 位まで出す */
export function durationHoursText(hours: number): string {
  return decimalFormatter.format(hours);
}
